// Auto-generated resource for About — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const AboutKeys = {
  Title: 'About.Title',
  MetaDescription: 'About.MetaDescription',
  Heading: 'About.Heading',
  VideoAria: 'About.VideoAria',
  VideoText: 'About.VideoText',
  ClosingPrompt: 'About.ClosingPrompt',
  OpenPlayground: 'About.OpenPlayground',
  SeePremium: 'About.SeePremium',
  BuyCoffee: 'About.BuyCoffee',
  CheckoutFailed: 'About.CheckoutFailed',
  OpeningCheckout: 'About.OpeningCheckout',
  TryAgain: 'About.TryAgain',
} as const;

export const AboutValues = {
  'default': {
    'BuyCoffee': 'Buy me a coffee ☕',
    'CheckoutFailed': 'Could not start checkout. Please try again.',
    'ClosingPrompt': 'Ready to start practising?',
    'Heading': 'The story behind VoiceDojo',
    'MetaDescription': 'The story behind VoiceDojo: why it was built and who built it.',
    'OpenPlayground': 'Open the Playground',
    'OpeningCheckout': 'Opening checkout…',
    'SeePremium': 'See what Premium includes',
    'Title': 'About · VoiceDojo',
    'TryAgain': 'Try again',
    'VideoAria': 'Video coming soon',
    'VideoText': '*(to be recorded and uploaded. This will be one of my preps. I put it here so that I WILL have to record it, one day…)*',
  },
  'vi-VN': {
    'BuyCoffee': 'Mời tôi một ly cà phê ☕',
    'CheckoutFailed': 'Không thể bắt đầu thanh toán. Vui lòng thử lại.',
    'ClosingPrompt': 'Bạn sẵn sàng luyện tập chưa?',
    'Heading': 'Câu chuyện đằng sau VoiceDojo',
    'MetaDescription': 'Câu chuyện đằng sau VoiceDojo: tại sao voicedojo ra đời?',
    'OpenPlayground': 'Mở Sân chơi',
    'OpeningCheckout': 'Đang mở trang thanh toán…',
    'SeePremium': 'Xem Premium có gì',
    'Title': 'Giới thiệu · VoiceDojo',
    'TryAgain': 'Thử lại',
    'VideoAria': 'Video sắp ra mắt',
    'VideoText': '*(Đây sẽ là một bài luyện tập cho chính tôi. Tôi đặt nó ở đây để nhắc tôi là tôi SẼ phải ghi hình một video giới thiệu về mình, một ngày nào đó…)*',
  },
} as const;

